export default "__VITE_ASSET__Bg9q9EDo__"